import { render } from "./AjakavaTabel.vue?vue&type=template&id=73f593f4&scoped=true&ts=true"
import script from "./AjakavaTabel.vue?vue&type=script&lang=ts"
export * from "./AjakavaTabel.vue?vue&type=script&lang=ts"

import "./AjakavaTabel.vue?vue&type=style&index=0&id=73f593f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73f593f4"]])

export default __exports__